/** Every `ProviderId` member, in the exact order declared by the YAML enum. */
export const PROVIDER_IDS = ['frenet', 'superfrete', 'melhor_envio'];
//# sourceMappingURL=provider-id.js.map